import Loader from '../Loader/Loader';
import { formatDatesInText } from '../../../utilities/dateHelpers';
import './XDAnalysis.css';

export interface XDAnalysisProps {
  headerText: string;
  value: string;
  loading: boolean | false;
}

const XDAnalysis = (props: XDAnalysisProps) => {
  const displayValue = formatDatesInText(props.value);
  return (
    <div className='flex-grow flex-shrink analysis-result-item-container xd-analysis-container'>
      <div className='analysis-result-item-header-container'>
        <label className='analysis-result-item-header-text'>{props.headerText}</label>
      </div>
      {props.loading && <Loader />}
      <div className='xd-analysis-text-container'>
        <textarea className='xd-analysis-textarea' readOnly value={displayValue} />
      </div>
    </div>
  );
};

export default XDAnalysis;
